import React from "react";
import { Layout, Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";

const { Content } = Layout;
const antIcon = <Loading3QuartersOutlined spin />;

type layoutProps = {
  loading: boolean;
  children: React.ReactNode;
};

const FullPageLayout = (props: layoutProps) => {
  const { loading, children } = props;

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Layout className="full_page_layout">
        <Content className="content_area">{children}</Content>
      </Layout>
    </Spin>
  );
};

export default FullPageLayout;
